var assocIndexOf = require('./_assocIndexOf');

/**
 * Sets the associative array `key` to `value`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 */
function assocSet(array, key, value) {
  var index = assocIndexOf(array, key);
  if (index < 0) {
    array.push([key, value]);
  } else {
    array[index][1] = value;
  }
}

module.exports = assocSet;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-touch/node_modules/lodash/_assocSet.js
// module id = ./node_modules/react-touch/node_modules/lodash/_assocSet.js
// module chunks = main